<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="项目" style="width:320px">
      <template #label>
        <el-button text type="danger" style="font-weight: normal;">
          <el-icon style="padding-right: 5px"><HomeFilled /></el-icon>项目
        </el-button>
      </template>
      <el-tree-select
        placeholder="选择项目"
        filterable
        style="width: 100%"
        :data="projectData"
        v-model="projectid"
        check-strictly
        :default-expand-all="true"
        :render-after-expand="false"
        :props="propsProject"
        @node-click="selectProject"
        class="date-input"
      />
    </el-form-item>
    <el-form-item label="" style="width:200px">
      <el-input
        v-model="queryParam.name"
        placeholder="搜索任务名称（按回车搜索）"
        :prefix-icon="Search"
        class="search-input"
        @keyup.enter="getListProjectTask"
      />
    </el-form-item>
    <el-form-item label="排序" style="margin-right:0">
      <template #label>
        <el-popover placement="bottom" :width="230" trigger="click">
          <template #reference>
            <el-button text style="font-weight: normal;"><el-icon style="padding-right: 5px"><Sort /></el-icon>排序</el-button>
          </template>
          <ul class="popverli">
            <li>
              <el-link :underline="false" @click="changeTaskOrder('created')" :class="[torder=='created' ? 'active' : '']">创建时间</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskOrder('changed')" :class="[torder=='changed' ? 'active' : '']">更新时间</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskOrder('ended')" :class="[torder=='ended' ? 'active' : '']">截止时间</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskOrder('started')" :class="[torder=='started' ? 'active' : '']">开始时间</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskOrder('completed')" :class="[torder=='completed' ? 'active' : '']">完成时间</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskOrder('status')" :class="[torder=='status' ? 'active' : '']">任务状态</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskOrder('level')" :class="[torder=='level' ? 'active' : '']">优先级</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskOrder('tag')" :class="[torder=='tag' ? 'active' : '']">标签</el-link>
            </li>
          </ul>
        </el-popover>
      </template>
    </el-form-item>
    <el-form-item label="分组" style="margin-right:0">
      <template #label>
        <el-popover placement="bottom" :width="230" trigger="click">
          <template #reference>
            <el-button text style="font-weight: normal;"><el-icon style="padding-right: 5px"><Connection /></el-icon>分组</el-button>
          </template>
          <ul class="popverli">
            <li>
              <el-link :underline="false" @click="changeTaskGroup('group')" :class="[tgroup=='group' ? 'active' : '']">自定义分组</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskGroup('status')" :class="[tgroup=='status' ? 'active' : '']">任务状态</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskGroup('level')" :class="[tgroup=='level' ? 'active' : '']">优先级</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskGroup('leader')" :class="[tgroup=='leader' ? 'active' : '']">负责人</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskGroup('create')" :class="[tgroup=='create' ? 'active' : '']">创建人</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskGroup('tag')" :class="[tgroup=='tag' ? 'active' : '']">任务标签</el-link>
            </li>
          </ul>
        </el-popover>
      </template>
    </el-form-item>
    <el-form-item label="层级" style="margin-right:0">
      <template #label>
        <el-popover placement="bottom" :width="230" trigger="click">
          <template #reference>
            <el-button text style="font-weight: normal;"><el-icon style="padding-right: 5px"><Operation /></el-icon>层级</el-button>
          </template>
          <ul class="popverli">
            <li>
              <el-link :underline="false" @click="changeTaskLevel(1)" :class="[tlevel==1 ? 'active' : '']">展开到1级任务</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskLevel(2)" :class="[tlevel==2 ? 'active' : '']">展开到2级任务</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskLevel(3)" :class="[tlevel==3 ? 'active' : '']">展开到3级任务</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskLevel(4)" :class="[tlevel==4 ? 'active' : '']">展开到4级任务</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskLevel(5)" :class="[tlevel==5 ? 'active' : '']">展开到5级任务</el-link>
            </li>
            <li>
              <el-link :underline="false" @click="changeTaskLevel(6)" :class="[tlevel==6 ? 'active' : '']">展开到6级任务</el-link>
            </li>
          </ul>
        </el-popover>
      </template>
    </el-form-item>
    <el-form-item style="margin-right:0">
      {{total}} 个任务
    </el-form-item>
    <el-form-item style="float:right">
      <el-button
        type="danger"
        @click="(dialog = true), doChangePlevel(1, 0), doTaskAdd('one')"
        v-hasPermission="['market:project:add']"
        ><el-icon class="picon"><Plus /></el-icon>新建任务</el-button
      >
    </el-form-item>
  </el-form>
  <el-row class="mainTableBox">
    <el-col :span="24">
      <el-scrollbar>
        <div class="scrollbar-flex-content" v-loading="loadingData">

          <el-card
            class="box-card scrollbar-demo-item1"
            :body-style="{ padding: '0px 10px 10px 10px' }"
            v-for="(item) in header" :key="item.configvalue"
          >
            <template #header>
              <div class="card-header">
                <span>{{item.configname}}</span>
                <el-popover
                  placement="right-start"
                  :width="230"
                  trigger="click"
                >
                  <template #reference>
                    <el-button text><el-icon> <MoreFilled /> </el-icon></el-button>
                  </template>
                  <ul class="popverli">
                    <li>
                      <el-link :underline="false" @click="(dialog = true), doChangePlevel(1, 0), doTaskAdd('one'),doDefaultValue(item.configvalue)"><el-icon> <Plus /> </el-icon>新建任务</el-link>
                    </li>
                    <li v-if="tgroup == 'group'">
                      <el-link :underline="false" @click="doGroupEdit(item),dialogGroupFormVisible = true"><el-icon> <EditPen /> </el-icon>重命名</el-link>
                    </li>
                    <!-- <li>
                    <el-popconfirm
                      confirm-button-type="danger"
                      confirm-button-text="确定"
                      cancel-button-text="取消"
                      icon-color="#626AEF"
                      title="删除分组后，分组下的所有任务将会一并删除，且不可恢复，确认要删除分组吗？"
                      width="300px"
                      @confirm="doTaskDelete(scope.$index, {projectid:projectid,diygroup:item.configvalue})"
                    >
                      <template #reference>
                        <el-link
                        v-hasRole="['admin']"
                          size="small"
                          type="danger"
                          ><el-icon> <Delete /> </el-icon>删除</el-link
                      >
                    </template>
                    </el-popconfirm>
                     
                    </li> -->
                  </ul>
                </el-popover>
              </div>
              
            </template>
            <el-scrollbar height="500px">
            <div v-for="(item1) in newData" :key="item1.key">
              <div v-if="item1.key==item.configvalue">
                <el-progress :percentage="getTaskCount(item1.childList)" color="#73d897"/>

                <div v-for="(item2) in item1.childList" :key="item2.key" >
                  <div class="taskbox" :style="{borderLeft:'2px solid',borderLeftColor:getTaskLevel(item2.item.level)}" @click="(dialog = true), doChangePlevel(1,item2.item.taskid),doTaskEdit(item2.item)">
                    <div class="tasktitle" >
                      <h1>{{ item2.item.name.substring(0,12) }}</h1>
                      <el-popover
                      placement="right-start"
                      :width="180"
                      trigger="click"
                      >
                      <template #reference>
                        <el-button text @click.stop="1==1"><el-icon><MoreFilled /> </el-icon></el-button>
                      </template>
                      <ul class="popverli">
                        <li>
                          <el-link :underline="false" @click="doMoveTaskOperate(item2.item)"><el-icon> <Position /> </el-icon>移动</el-link>
                        </li>
                        <li>
                          <el-link :underline="false" @click="doCopyTaskOperate(item2.item)"><el-icon> <CopyDocument /> </el-icon>拷贝</el-link>
                        </li>
                        <li>
                          <el-link :underline="false" type="danger" @click="doTaskDelete(0,{taskid:item2.item.taskid})"><el-icon> <Delete /> </el-icon>删除</el-link>
                        </li>
                      </ul>
                      </el-popover>
                    </div>
                    <div class="taskstatus">
                      <el-tag type="success" round v-if="getConfigName(1,item2.item.status)==='已完成'"><el-icon><CircleCheck /></el-icon> {{getConfigName(1,item2.item.status)}} </el-tag>
                      <el-tag type="warning" round v-else-if="getConfigName(1,item2.item.status)==='进行中'"><el-icon><Clock /></el-icon> {{getConfigName(1,item2.item.status)}} </el-tag>
                      <el-tag type="danger" round v-else><el-icon><SwitchButton /></el-icon> {{getConfigName(1,item2.item.status)}} </el-tag>
                      <el-button type="danger" plain circle v-if="item2.item.leader.nickname">{{ item2.item.leader.nickname.substring(0,1) }}</el-button>
                    </div>
                    <div class="tasktime">
                      <el-tag type="info" round> 更新时间: {{util.formatDateUnix(item2.item.changed, "MM月dd日 hh:mm")}} </el-tag>
                      <el-tag type="danger" round> 任务时间: {{util.formatDateUnix(item2.item.started, "MM月dd日")}} <span v-if="item2.item.ended">至 {{util.formatDateUnix(item2.item.ended, "MM月dd日")}}</span> </el-tag>
                    </div>
                  </div>
                  
                </div>
              </div>

              
             
            </div>
            <el-link :underline="false" @click="(dialog = true), doChangePlevel(1, 0), doTaskAdd('one'),doDefaultValue(item.configvalue)"><el-icon style="padding-right:5px"> <Plus /> </el-icon>添加新任务</el-link>
            
            </el-scrollbar>
          </el-card>

          <div style="padding:80px;margin: 0 auto" v-if="header && !header.length">
            <el-empty image-size="100" description="暂无任务数据" />
          </div>


          
        </div>
      </el-scrollbar>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"></el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
          :hide-on-single-page="true"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    class="drawerBox"
    direction="rtl"
    size="80%"
    :show-close="false"
  >
    <template #header="{ titleId, titleClass }" style="margin-bottom: 5px">
      <h4 :id="titleId" :class="titleClass">{{ title }}</h4>
      <el-button type="danger" :loading="loading" @click="doTaskSave" v-if="plevel==1">{{
        loading ? "保存中 ..." : "保存"
      }}</el-button>
      <el-button type="danger" :loading="loading" @click="doTaskSave" v-if="plevel>1">{{
        loading ? "保存中 ..." : "保存并返回上一级"
      }}</el-button>
      <el-button @click="doTaskClose" text>
        <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
        关闭
      </el-button>
    </template>

    <div class="common-drawer__content">
      <el-form ref="taskFormRef" :model="taskForm" autocomplete="off">
        <div style="font-size:14px;line-height:30px" v-if="pname"><el-link @click="doReturnParent" :underline="false" style="color:#888"><el-icon><HomeFilled /></el-icon> 父任务：{{pname}}</el-link></div>
        <div>
          <el-input
            class="title-input"
            ref="nameRef"
            v-model.trim="taskForm.name"
            placeholder="请输入任务名称"
            size="large"
          />
        </div>
        <div
          style="
            justify-content: space-between;
            display: flex;
            margin-top: 20px;
            font-size: 14px;
            padding: 40px;
          "
        >
          <div style="display: flex">
            <el-icon size="40"> <PieChart /> </el-icon>
            <div style="display: grid; padding-left: 10px">
              <el-tree-select
                ref="statusRef"
                placeholder="选择任务状态"
                filterable
                suffix-icon=""
                style="width: 100%"
                :data="configForm.status"
                v-model="taskForm.status"
                check-strictly
                :default-expand-all="true"
                :render-after-expand="false"
                :props="propsConfig"
                @node-click="selectConfig($event, 1)"
                class="date-input"
              />
              <span class="txted">当前状态</span>
            </div>
          </div>
          <div style="display: flex">
            <el-icon size="40"> <User /> </el-icon>
            <div style="display: grid; padding-left: 10px">
              <el-tree-select
                ref="leaderidRef"
                placeholder="选择负责人"
                filterable
                suffix-icon=""
                style="width: 100%"
                :data="userData"
                v-model="taskForm.leaderid"
                check-strictly
                :default-expand-all="true"
                :render-after-expand="false"
                :props="propsUser"
                @node-click="selectUser"
                class="date-input"
              />
              <span class="txted">负责人</span>
            </div>
          </div>
          <div style="display: flex">
            <el-icon size="40"> <Calendar /> </el-icon>
            <div style="display: grid; padding-left: 10px">
              <el-date-picker
                ref="startedRef"
                v-model="taskStartDate"
                type="datetime"
                placeholder="选择开始时间"
                :shortcuts="shortcuts"
                prefix-icon="none"
                class="date-input"
                format="YYYY/MM/DD hh:mm"
                value-format="YYYY-MM-DD hh:mm"
                style="width: 120px"
                @change="changeTaskDate"
              /><span class="txted">开始时间</span>
            </div>
          </div>
          <div style="display: flex">
            <el-icon size="40"><Wallet /></el-icon>
            <div style="display: grid; padding-left: 10px">
              <el-date-picker
                ref="endedRef"
                v-model="taskEndDate"
                type="datetime"
                placeholder="选择结束时间"
                :shortcuts="shortcuts"
                prefix-icon="none"
                class="date-input"
                format="YYYY/MM/DD hh:mm"
                value-format="YYYY-MM-DD hh:mm"
                style="width: 120px"
                @change="changeTaskDate"
              /><span class="txted">结束时间</span>
            </div>
          </div>
        </div>

        <el-tabs v-model="activeName"  @tab-click="doTabClick">
          <el-tab-pane label="任务信息" name="first">
            <el-descriptions :column="4" direction="vertical">
              <el-descriptions-item
                label="参与人"
                label-class-name="my-label"
                :span="4"
              >
                <el-tree-select
                  ref="joinidRef"
                  placeholder="选择参与人，可多选"
                  filterable
                  multiple
                  suffix-icon=""
                  style="width: 100%"
                  :data="userData"
                  v-model="taskJoinid"
                  check-strictly
                  :default-expand-all="true"
                  :render-after-expand="false"
                  :props="propsUser"
                  @node-click="selectUsers"
                  class="date-input"
                />
              </el-descriptions-item>
              <el-descriptions-item
                label="所属分组"
                label-class-name="my-label"
                :span="1"
                ><el-tree-select
                  ref="diygroupRef"
                  placeholder="选择任务分组"
                  filterable
                  suffix-icon=""
                  style="width: 100%"
                  :data="configForm.groups"
                  v-model="taskForm.diygroup"
                  check-strictly
                  :default-expand-all="true"
                  :render-after-expand="false"
                  :props="propsConfig"
                  @node-click="selectConfig($event, 2)"
                  class="date-input"
              /></el-descriptions-item>
              <el-descriptions-item
                label="优先级"
                label-class-name="my-label"
                :span="2"
                ><el-tree-select
                  ref="levelRef"
                  placeholder="选择任务优先级"
                  filterable
                  suffix-icon=""
                  style="width: 100%"
                  :data="configForm.levels"
                  v-model="taskForm.level"
                  check-strictly
                  :default-expand-all="true"
                  :render-after-expand="false"
                  :props="propsConfig"
                  @node-click="selectConfig($event, 4)"
                  class="date-input"
              /></el-descriptions-item>
              <el-descriptions-item
                label="标签"
                label-class-name="my-label"
                :span="2"
                ><el-tree-select
                  ref="tagRef"
                  placeholder="选择任务标签"
                  filterable
                  suffix-icon=""
                  style="width: 100%"
                  :data="configForm.tags"
                  v-model="taskForm.tag"
                  check-strictly
                  :default-expand-all="true"
                  :render-after-expand="false"
                  :props="propsConfig"
                  @node-click="selectConfig($event, 3)"
                  class="date-input"
              /></el-descriptions-item>
              <el-descriptions-item
                label="当前遇见的问题"
                label-class-name="my-label"
                :span="4"
              >
                <div class="cimg" v-show="!qVisible" @click="qVisible = true" v-html="taskForm.question"></div>
                <editor
                  v-show="qVisible"
                  ref="editorQuestionRef"
                  :content="taskForm.question"
                  @update:content="updateQuestion"
                ></editor>
              </el-descriptions-item>
              <el-descriptions-item
                label="需要的资源/帮助"
                label-class-name="my-label"
                :span="4"
              >
              <div class="cimg" v-show="!hVisible" @click="hVisible = true" v-html="taskForm.help"></div>
                <editor
                  v-show="hVisible"
                  ref="editorHelpRef"
                  :content="taskForm.help"
                  @update:content="updateHelp"
                ></editor>
              </el-descriptions-item>

              <el-descriptions-item
                label="描述"
                label-class-name="my-label"
                :span="4"
              >
              <div class="cimg" v-show="!cVisible" @click="cVisible = true" v-html="taskForm.content"></div>
                <editor
                  v-show="cVisible"
                  ref="editorContentRef"
                  :content="taskForm.content"
                  @update:content="updateContent"
                ></editor>
              </el-descriptions-item>
            </el-descriptions>
            <div style="color:#888;font-size:13px" v-if="taskForm.user">{{taskForm.user.nickname}} 创建于 {{util.formatDateUnix(taskForm.created, "yyyy年MM月dd日 hh:mm")}} 更新于{{util.formatDateUnix(taskForm.changed, "yyyy年MM月dd日 hh:mm")}}</div>
          </el-tab-pane>
          <el-tab-pane label="子任务" name="second" v-if="activeVistrual">
            <el-table :data="taskDataChild" style="width: 100%">
              <el-table-column prop="name">
                <template #header> 共有{{totalChild}}个任务 </template>
                <template #default="scope">
                  {{ scope.row.name}}
                </template>
              </el-table-column>
              <el-table-column prop="status">
                <template #default="scope">
                  <el-tag
                    round
                    type="danger"
                    disable-transitions
                    ><span v-text="getConfigName(1,scope.row.status)"></span>
                  </el-tag>
              </template>
              </el-table-column>
              <el-table-column prop="leader">
                <template #default="scope">
                  <el-tag
                    round
                    type="warning"
                    disable-transitions
                    ><span v-text="scope.row.leader.nickname"></span>
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="started">
                <template #default="scope">
                  {{util.formatDateUnix(scope.row.started, "MM月dd日")}} <span v-if="scope.row.ended">至 {{util.formatDateUnix(scope.row.ended, "MM月dd日")}}</span> 
                </template>
              </el-table-column>
              <el-table-column align="right">
                <template #header>
                  <el-button text @click="(dialog = true), doChangePlevel(taskForm.plevel+1, taskForm.taskid), doTaskAdd('more')"
                    ><el-icon> <Plus /> </el-icon> 新建</el-button
                  >
                </template>
                <template #default="scope">
                  <el-link
                    type="primary"
                    size="small"
                    @click="doChangePlevel(scope.row.plevel, scope.row.parentid),doTaskEdit(scope.row)"
                    >修改</el-link
                  >
                  <el-popconfirm
                    confirm-button-type="danger"
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon-color="#626AEF"
                    title="您确定要删除吗？删除后且不可恢复。"
                    width="200px"
                    @confirm="doTaskDelete(scope.$index, scope.row)"
                  >
                    <template #reference>
                      <el-link
                      v-hasRole="['admin']"
                        size="small"
                        type="danger"
                        >删除</el-link
                      >
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="附件" name="third" v-if="activeVistrual">
            <el-table :data="taskDataAttachment" style="width: 100%">
              <el-table-column prop="suffix" width="130">
                <template #header> 共有{{totalAttachment}}个附件 </template>
                <template #default="scope">
                  <img :src="require('@/assets/image/suffix/'+util.showSuffix(scope.row.suffix)+'') " style="width:40px" />
                </template>
              </el-table-column>
              <el-table-column prop="name" width="300"></el-table-column>
              <el-table-column prop="sizes">
                <template #default="scope">
                  <el-tag
                    round
                    disable-transitions
                    ><span v-text="util.formatFileSize(scope.row.sizes)"></span>
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="user">
                <template #default="scope">
                    <span style="color:#909399">来自 </span><span v-text="scope.row.user.nickname"></span>
                </template>
              </el-table-column>
              <el-table-column prop="changed">
                <template #default="scope">
                  {{util.formatDateUnix(scope.row.changed, "MM月dd日 hh:mm")}}
                </template>
              </el-table-column>
              <el-table-column prop="address" align="right" width="300">
                <template #header>
                  <el-upload
                    ref="upload"
                    action="/api/project/task/upload"
                    :data="{taskid:taskForm.taskid,projectid:taskForm.projectid}"
                    :headers="headerUpload"
                    :on-success="doUploadSuccess"
                    :limit="1"
                    :auto-upload="true"
                  ><el-button text><el-icon> <Plus /> </el-icon>上传附件</el-button>
                  </el-upload>

                </template>
                <template #default="scope">
                  <el-link
                    type="primary"
                    size="small"
                    @click="doAttachmentEdit(scope.row),dialogFormVisible = true"
                    >修改</el-link
                  >
                  <el-link
                    size="small"
                    type="primary"
                    @click="doDownloadProjectTaskAttachment(scope.row.paths,scope.row.name,scope.row.suffix)"
                    >下载</el-link
                  >
                  <el-popconfirm
                    confirm-button-type="danger"
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon-color="#626AEF"
                    title="您确定要删除吗？"
                    width="200px"
                    @confirm="doTaskAttachmentDelete(scope.$index, scope.row)"
                  >
                    <template #reference>
                      <el-link
                      v-hasRole="['admin']"
                        size="small"
                        type="danger"
                        >删除</el-link
                      >
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="日志" name="fourth" v-if="activeVistrual">
            <el-table :data="taskDataLog" style="width: 100%" stripe>
              <el-table-column prop="userid" width="200">
                <template #header> 共有{{totalLog}}个日志记录 </template>
                <template #default="scope">
                  {{ scope.row.user.nickname }}
                </template>
              </el-table-column>
              <el-table-column prop="content">
                <template #default="scope">
                  <el-tag
                    round
                    disable-transitions
                    ><span v-text="scope.row.content"></span>
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="user">
                <template #default="scope">
                    
                  <el-text type="info">{{getConfigNameLog(scope.row.field,scope.row.froms)}}</el-text>
                  
                  <span style="color:#909399;padding:0 5px"><el-icon v-if="scope.row.tos"><Right /></el-icon> </span>
                  
                  <el-text v-if="scope.row.tos">{{getConfigNameLog(scope.row.field,scope.row.tos)}}</el-text>
                </template>
              </el-table-column>
              <el-table-column prop="created">
                <template #default="scope">
                  <el-text type="info">{{util.formatDateUnix(scope.row.created, "MM月dd日 hh:mm")}}</el-text>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="流转" name="fifth" v-if="activeVistrual">

            <el-timeline>
              <el-timeline-item v-for="(item, index) in taskDataStatus" :key="index" placement="top" :timestamp="item.timestamp">
                <div>
                  <h4><el-tag
                    :type="item.color"
                    round
                    disable-transitions
                    ><span v-text="item.status"></span>
                  </el-tag></h4>
                  <p>{{item.nickname}} <span style="color:#909399;padding:0 5px">提交于</span> {{item.timestamp}}</p>
                </div>
              </el-timeline-item>
            </el-timeline>

          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
  </el-drawer>
  <el-dialog v-model="dialogFormVisible" title="附件重命名">
    <el-form :model="formAttachment">
      <el-form-item label="">
        <el-input v-model.trim="formAttachment.name" autocomplete="off" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false" text>取消</el-button>
        <el-button type="primary" @click="doAttachmentEditSave()">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="dialogGroupFormVisible" title="分组重命名">
    <el-form :model="formGroup">
      <el-form-item label="">
        <el-input v-model.trim="formGroup.configname" autocomplete="off" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogGroupFormVisible = false" text>取消</el-button>
        <el-button type="primary" @click="doGroupEditSave()">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="dialogMoveFormVisible" title="移动任务">
    <el-form :model="moveForm" label-position="top">
      <el-form-item label="任务名称">
        <el-input v-model.trim="moveForm.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="移动至项目">
        <el-tree-select
        placeholder="选择项目"
        filterable
        style="width: 100%"
        :data="projectData"
        v-model="moveForm.projectid"
        check-strictly
        :default-expand-all="true"
        :render-after-expand="false"
        :props="propsProject"
        @node-click="selectProjectMove"
      />
      </el-form-item>
      <el-form-item label="任务分组">
        <el-tree-select
          ref="diygroupRef"
          placeholder="选择任务分组"
          filterable
          style="width: 100%"
          :data="configMove"
          v-model="moveForm.diygroup"
          check-strictly
          :default-expand-all="true"
          :render-after-expand="false"
          :props="propsConfig"
          @node-click="selectConfig($event, 2)"
        />
      </el-form-item>
      <el-alert type="info" show-icon :closable="false">
        <p>只移动此任务基本信息（不包含负责人、参与人、状态、等级、标签）、<span style="color:#f56c6c">子任务</span>、附件和日志，<span style="color:#f56c6c">一旦移动，本项目下无此任务信息。</span></p>
      </el-alert>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogMoveFormVisible = false" text>取消</el-button>
        <el-button type="primary" @click="doMoveTask()">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="dialogCopyFormVisible" title="拷贝任务">
    <el-form :model="copyForm" label-position="top">
      <el-form-item label="任务名称">
        <el-input v-model.trim="copyForm.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="拷贝至项目">
        <el-tree-select
        placeholder="选择项目"
        filterable
        style="width: 100%"
        :data="projectData"
        v-model="copyForm.projectid"
        check-strictly
        :default-expand-all="true"
        :render-after-expand="false"
        :props="propsProject"
        @node-click="selectProjectMove"
      />
      </el-form-item>
      <el-form-item label="任务分组">
        <el-tree-select
          ref="diygroupRef"
          placeholder="选择任务分组"
          filterable
          style="width: 100%"
          :data="configMove"
          v-model="copyForm.diygroup"
          check-strictly
          :default-expand-all="true"
          :render-after-expand="false"
          :props="propsConfig"
          @node-click="selectConfig($event, 2)"
        />
      </el-form-item>
      <el-alert type="info" show-icon :closable="false">
        <p>只拷贝此任务基本信息（不同项目之间：不包含负责人、参与人、状态、等级、标签）、附件</p>
      </el-alert>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogCopyFormVisible = false" text>取消</el-button>
        <el-button type="primary" @click="doCopyTask()">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
      
<script setup>
import { ref, onMounted } from "vue";
// import { useRouter } from "vue-router";
import { ElDrawer, ElMessage } from "element-plus";
import { listProject,listProjectUser } from "@/api/project";
import { listProjectConfig,saveProjectConfig } from "@/api/project";
import { listProjectTask, saveProjectTask, getProjectTaskInfo, deleteProjectTask, listProjectTaskAttachment,saveProjectTaskAttachment,deleteProjectTaskAttachment, listProjectTaskLog,moveProjectTask,copyProjectTask } from "@/api/task";

import { download } from "@/api/common";

import { Search } from '@element-plus/icons-vue'

import editor from "@/components/common/editorSimple.vue";

import storage from "@/util/storage";
import util from "@/util/tool.js";

// import aes from "@/util/aes.js";

import store from "@/store";



// const router = useRouter();
// let open = (routeName, row) => {
//   storage.saveSessionObject("projectPath",queryParam.value)
//   router.push({
//     name: routeName,
//     params: { id: row.projectid },
//     // query: { name: row.name },
//   });
// };

// let openImport = (routeName)=>{
//   router.push({
//     name: routeName
//   });
// }
// const visible1 = ref(false)
// const visible2 = ref(false)

const dialogFormVisible = ref(false)

const editorQuestionRef = ref();
const editorHelpRef = ref();
const editorContentRef = ref();
const qVisible = ref(false)
const hVisible = ref(false)
const cVisible = ref(false)

const checkProjectUser = ref(false)


const updateQuestion = (e) => {
  taskForm.value.question = e;
};

const updateHelp = (e) => {
  taskForm.value.help = e;
};

const updateContent = (e) => {
  taskForm.value.content = e;
};


let timer;
let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);
const drawerRef = ref(ElDrawer);
const taskFormRef = ref();

const total = ref(0);
const totalChild = ref(0)
const pageSize = ref(3000); //每页显示条数

let title = ref("新建任务");

const activeName = ref("first");
const activeVistrual = ref(true)

const projectid = ref();

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  projectid: "",
  parentid: "",
  orderField: "taskid",
  orderType: "desc"
});
const queryParamChild = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  projectid: null,
  parentid: null,
});
const queryParamAttachmentLog = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  projectid: null,
  taskid: null,
});

const parentid = ref()
const plevel = ref(1)

const taskForm = ref({
  taskid: null,
  projectid: null,
  parentid:null,
  plevel:1,
  name: "",
  started: "",
  ended: "",
  leaderid: "",
  joinid: "",
  status: "",
  level: "",
  tag: "",
  question: "",
  help: "",
  content: "",
  diygroup: "",
  created:'',
  changed:'',
  user: {
    nickname: ''
  }
});

let taskStartDate = ref();
let taskEndDate = ref();
const changeTaskDate = () => {
  if (taskStartDate.value) {
    taskForm.value.started = Date.parse(taskStartDate.value + ":00");
  }
  if (taskEndDate.value) {
    taskForm.value.ended = Date.parse(taskEndDate.value + ":59");
  }
  if (taskForm.value.started >= taskForm.value.ended && taskForm.value.ended) {
    ElMessage.error("开始时间不能大于结束时间");
    taskStartDate.value = "";
    taskEndDate.value = "";
    taskForm.value.started = "";
    taskForm.value.ended = "";
  }
};

//统计进度条数值
const getTaskCount = (data) => {
  let complete = 0
  data.forEach((item) => {
    if (getConfigName(1,item.item.status) ==='已完成') {
      complete++
    }
  });
  return parseInt((complete/data.length * 100).toFixed(0))
}
const getTaskLevel = (level) => {
  let complete = '#f4d66d'
  if (getConfigName(4,level) ==='最高') {
    complete = '#fa8888'
  }
  if (getConfigName(4,level) ==='较高') {
    complete = '#fb7fb7'
  }
  if (getConfigName(4,level) ==='较低') {
    complete = '#5dcfff'
  }
  if (getConfigName(4,level) ==='最低') {
    complete = '#40e0c3'
  }
  if (getConfigName(4,level) ==='普通') {
    complete = '#f4d66d'
  }
  return complete
}

// 用户表API
let taskJoinid = ref();
const selectUsers = (v1) => {
  taskJoinid.value = v1.leaderid;
};
const selectUser = (v1) => {
  taskForm.value.leaderid = v1.leaderid;
};
const propsUser = ref({
  checkStrictly: true,
  value: "leaderid",
  label: "name",
});
const userReset = (users) => {
  let dataTmp = [];
  let loginUserId = store.state.user.userId.toString()

  // console.log('loginUserId---',loginUserId)
  users.forEach((user) => {
    user.leaderid = user.userid.toString();
    user.name = user.username + " (" + user.nickname + ")";
    dataTmp.push(user);

    if (loginUserId==user.userid.toString()) {
      //console.log('user.userid---',user.userid.toString())

      //console.log('user.userid---loginUserId--0k',)

      checkProjectUser.value = true
    }
  });

  //console.log('user---',checkProjectUser.value)
  return dataTmp;
};
const userData = ref([]);
const getListUser = () => {
  listProjectUser({ projectid: projectid.value ,pageNo: 1, pageSize: 5000 }).then((res) => {
    userData.value = userReset(res.data.extend.pages.list);
  });
};

//项目配置表API
const configForm = ref({
  status: [],
  groups: [],
  tags: [],
  levels: [],
});
const getConfigName = (configtype,value) => {
  let configname = '无'
  let tmpData = []
  if (configtype==1) {
    tmpData = configForm.value.status
  }
  if (configtype==2) {
    tmpData = configForm.value.groups
  }
  if (configtype==3) {
    tmpData = configForm.value.tags
  }
  if (configtype==4) {
    tmpData = configForm.value.levels
  }
  tmpData.forEach((config) => {
      if (config.configvalue == value)
      configname = config.configname
    })
  return configname

}
const selectConfig = (e, v1) => {
  if (v1 == 1) {
    taskForm.value.status = e.configvalue;
  }
  if (v1 == 2) {
    taskForm.value.diygroup = e.configvalue;
    // moveConfigid.value = e.configvalue;
    moveForm.value.diygroup = e.configvalue;
  }
  if (v1 == 3) {
    taskForm.value.tag = e.configvalue;
  }
  if (v1 == 4) {
    taskForm.value.level = e.configvalue;
  }
};
const propsConfig = ref({
  checkStrictly: true,
  value: "configvalue",
  label: "configname",
});
const projectConfigReset = (configs) => {
  configs.forEach((config) => {
    if (config.configtype == 1) {
      configForm.value.status.push({
        configid: config.configid.toString(),
        configvalue: config.configvalue,
        configname: config.configname,
        configtype: config.configtype,
      });
    }
    if (config.configtype == 2) {
      configForm.value.groups.push({
        configid: config.configid.toString(),
        configvalue: config.configvalue,
        configname: config.configname,
        configtype: config.configtype,
      });
    }
    if (config.configtype == 3) {
      configForm.value.tags.push({
        configid: config.configid.toString(),
        configvalue: config.configvalue,
        configname: config.configname,
        configtype: config.configtype,
      });
    }
    if (config.configtype == 4) {
      configForm.value.levels.push({
        configid: config.configid.toString(),
        configvalue: config.configvalue,
        configname: config.configname,
        configtype: config.configtype,
      });
    }
  });
  //taskReset()

};
const getListProjectConfig = (configtype) => {
  listProjectConfig({
    configtype,
    projectid: projectid.value,
    pageNo: 1,
    pageSize: 1000,
  }).then((res) => {
    let tmpData = res.data.extend.pages.list
    configForm.value = {
        status: [],
        groups: [],
        tags: [],
        levels: [],
      };
    // if (tmpData.length <= 0) {
    //   configForm.value = {
    //     status: [],
    //     groups: [],
    //     tags: [],
    //     levels: [],
    //   };
    // } else {
      projectConfigReset(tmpData);
    // }
  });
};

const doTabClick = (tab) => {
  if (tab.props.name == 'second') {
    queryParamChild.value.parentid = taskForm.value.taskid.toString()
    queryParamChild.value.projectid = projectid.value
    getListProjectTaskChild()
  }
  if (tab.props.name == 'third') {
    queryParamAttachmentLog.value.taskid = taskForm.value.taskid.toString()
    queryParamAttachmentLog.value.projectid = projectid.value
    getListProjectTaskAttachment()
  } 
  if (tab.props.name == 'fourth') {
    queryParamAttachmentLog.value.taskid = taskForm.value.taskid.toString()
    queryParamAttachmentLog.value.projectid = projectid.value
    getListProjectTaskLog()
  }
  if (tab.props.name == 'fifth') {
    queryParamAttachmentLog.value.taskid = taskForm.value.taskid.toString()
    queryParamAttachmentLog.value.projectid = projectid.value
    getListProjectTaskStatus()
  }
}


//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("projectPath");
  if (query) {
    queryParam.value = query;
  }

  // let encrypt = aes.encrypt('hello');
  // console.log('加密之后：', encrypt);

  // let dncrypt = aes.decrypt('LFwtExvt8o4Xb0hLT3T1Rg==');
  // console.log('解密之后：', dncrypt);

  getListProject();
  setTimeout(() => {
    getListProjectConfig();
    getListProjectTask();
    getListUser();

  }, 500);
});

//分组重命名
const dialogGroupFormVisible = ref(false)
const formGroup = ref({
  configvalue:'',
  configname:'',
  configid:null
})

const doGroupEdit = (obj) => {
  formGroup.value.configvalue = obj.configvalue
  formGroup.value.configname = obj.configname
  formGroup.value.configid = obj.configid
  
}
const doGroupEditSave = () => {
  if (formGroup.value.configname == "" || formGroup.value.configname.length>100) {
    ElMessage.error("请填写名称并小于50字符");
    return;
  }
  saveProjectConfig(formGroup.value).then((res) => {
    timer = setTimeout(() => {
      if (res.data.code === 1) {
        dialogGroupFormVisible.value = false;
        configForm.value = {
          status: [],
          groups: [],
          tags: [],
          levels: [],
        };
        getListProjectConfig();
        taskReset()
      } else {
        ElMessage.error(res.data.msg);
      }
    }, 1000);
  });
}

//附件
const formAttachment = ref({
  attachmentid:null,
  name:''
})

const doAttachmentEdit = (obj) => {
  formAttachment.value.attachmentid = obj.attachmentid
  formAttachment.value.name = obj.name
}
const doAttachmentEditSave = () => {
  if (formAttachment.value.name == "" || formAttachment.value.name.length>100) {
    ElMessage.error("请填写附件名称并小于100字符");
    return;
  }
  saveProjectTaskAttachment(formAttachment.value).then((res) => {
    timer = setTimeout(() => {
      if (res.data.code === 1) {
        dialogFormVisible.value = false;
        getListProjectTaskAttachment();
      } else {
        ElMessage.error(res.data.msg);
      }
    }, 1000);
  });
}
const doTaskAttachmentDelete = (i, obj) => {
  deleteProjectTaskAttachment(obj).then((res) => {
    if (res.data.code === 1) {
      getListProjectTaskAttachment();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}

const doChangePlevel = (pvalue, pid) => {
  plevel.value = pvalue
  parentid.value = pid
  console.log('doChangePlevel:---',parentid.value.toString(),'----', plevel.value)
}
const doTaskAdd = (flag) => {
  activeVistrual.value = false
  activeName.value = 'first'
  parentid.value = taskForm.value.taskid

  qVisible.value = true
  hVisible.value = true
  cVisible.value = true

  title.value = "新建任务";

  qVisible.value = true
  hVisible.value = true
  cVisible.value = true

  taskJoinid.value = ''
  taskStartDate.value = ''
  taskEndDate.value = ''
  editorQuestionRef.value.valueHtml = "<p></p>";
  editorHelpRef.value.valueHtml = "<p></p>";
  editorContentRef.value.valueHtml = "<p></p>";

  resetForm();
  if (flag == 'one') {
    taskForm.value.parentid = ""
    taskForm.value.plevel = 1
  }
  if (flag == 'more') {
    taskForm.value.parentid = parentid.value
    taskForm.value.plevel = plevel.value
  }
};

const pname = ref()
const doTaskEdit = (obj) => {
  console.log('000',obj)
  activeVistrual.value = true
  activeName.value = 'first'
  title.value = "编辑任务";

  if (obj.parentid) {
    pname.value = taskForm.value.name
  } else {
    pname.value = ''
  }

  qVisible.value = false
  hVisible.value = false
  cVisible.value = false
  
  if (obj.started) {
    taskStartDate.value = util.formatDateUnix(obj.started, 'yyyy/MM/dd hh:mm:ss')
  }
  if (obj.ended) {
    taskEndDate.value = util.formatDateUnix(obj.ended, 'yyyy/MM/dd hh:mm:ss')
  }

  taskForm.value = {
    taskid: obj.taskid,
    projectid: obj.projectid,
    parentid: obj.parentid,
    plevel: obj.plevel,
    name: obj.name,
    started: obj.started,
    ended: obj.ended,
    leaderid: obj.leaderid ? obj.leaderid.toString() : null,
    joinid: obj.joinid,
    status: obj.status,
    level: obj.level,
    tag: obj.tag,
    diygroup: obj.diygroup,
    question: obj.question!='<p><br></p>' ? obj.question : '在此填写内容',
    help: obj.help!='<p><br></p>' ? obj.help : '在此填写内容',
    content: obj.content!='<p><br></p>' ? obj.content : '在此填写内容',

    created:obj.created,
    changed:obj.changed,
    user:{
      nickname:obj.user.nickname
    } 
  };
  taskJoinid.value = obj.joinid.split(",");

  setTimeout(() => {
    editorQuestionRef.value.valueHtml = taskForm.value.question;
    editorHelpRef.value.valueHtml = taskForm.value.help;
    editorContentRef.value.valueHtml = taskForm.value.content;
  }, 400);

  
};

const doTaskClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  taskFormRef.value.resetFields();
};

const resetForm = () => {
  taskForm.value = {
    taskid: null,
    projectid: projectid.value,
    name: "",
    started: "",
    ended: "",
    leaderid: "",
    joinid: "",
    status: "",
    level: "",
    tag: "",
    question: "",
    help: "",
    content: "",
    diygroup: "",
  };
};

const doReturnParent = () => {
    qVisible.value = false
    hVisible.value = false
    cVisible.value = false

    if (plevel.value>1 && parentid.value) {
      dialog.value = true;
      getProjectTaskInfos(parentid.value.toString())
      

      plevel.value = plevel.value - 1
      activeVistrual.value = true
      activeName.value = 'first'
      title.value = "编辑任务";
    }
}

const nameRef = ref();
const statusRef = ref();
const leaderidRef = ref();
const startedRef = ref();
const endedRef = ref();
const joinidRef = ref();
const diygroupRef = ref();
const levelRef = ref();
const tagRef = ref();

const doTaskSave = () => {
  if (taskForm.value.name == "") {
    ElMessage.error("请填写任务名称");
    nameRef.value.focus();
    return;
  }
  if (taskForm.value.status == "") {
    ElMessage.error("请选择任务状态");
    statusRef.value.focus();
    return;
  }
  if (taskForm.value.leaderid == "") {
    ElMessage.error("请选择任务负责人");
    leaderidRef.value.focus();
    return;
  }
  if (taskForm.value.started == "") {
    ElMessage.error("请选择任务开始时间");
    startedRef.value.focus();
    return;
  }
  if (taskForm.value.ended == "") {
    ElMessage.error("请选择任务结束时间");
    endedRef.value.focus();
    return;
  }

  if (taskForm.value.diygroup == "") {
    ElMessage.error("请选择任务分组");
    diygroupRef.value.focus();
    return;
  }
  if (taskForm.value.level == "") {
    ElMessage.error("请选择任务优先级");
    levelRef.value.focus();
    return;
  }
  if (taskForm.value.tag == "") {
    ElMessage.error("请选择任务标签");
    tagRef.value.focus();
    return;
  }
  taskForm.value.joinid = taskJoinid.value.join(",");

  if (taskForm.value.joinid == "") {
    ElMessage.error("请选择任务参与人");
    joinidRef.value.focus();
    return;
  }
  saveProjectTask(taskForm.value).then((res) => {
    loading.value = true;
    timer = setTimeout(() => {
      // 动画关闭需要一定的时间
      setTimeout(() => {
        loading.value = false;
      }, 400);
      if (res.data.code === 1) {
        getListProjectTask();
        qVisible.value = false
        hVisible.value = false
        cVisible.value = false

        if (plevel.value>1 && parentid.value) {
          loading.value = true;
          dialog.value = true;
          getProjectTaskInfos(parentid.value.toString())
          

          plevel.value = plevel.value - 1
          activeVistrual.value = true
          activeName.value = 'first'
          title.value = "编辑任务";
          getListProjectTaskChild()
        } else {
          doTaskClose();
        }
        
      } else {
        ElMessage.error(res.data.msg);
      }
    }, 1000);
  });
};

const doTaskDelete = (index, obj) => {
  deleteProjectTask(obj).then((res) => {
    if (res.data.code === 1) {
      getListProjectTask();
      getListProjectTaskChild()
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListProjectTask();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListProjectTask();
};

//移动
const dialogMoveFormVisible = ref(false)
const moveForm = ref({
  projectid: null,
  taskid: null,
  name: '',
  plevel:'',
  diygroup:'',
})

const configMove = ref([])
const selectProjectMove = (e) => {
  moveForm.value.projectid = e.projectid
  listProjectConfig({
    projectid: e.projectid,
    pageNo: 1,
    pageSize: 1000,
  }).then((res) => {
    let tmpData = res.data.extend.pages.list
    configMove.value = []
    tmpData.forEach((config) => {
      if (config.configtype == 2) {
        configMove.value.push({
          configid: config.configid.toString(),
          configvalue: config.configvalue,
          configname: config.configname,
          configtype: config.configtype,
        });
      }
    });
  });
};
const doMoveTaskOperate = (obj) => {
  dialogMoveFormVisible.value = true 
  moveForm.value.taskid = obj.taskid
  moveForm.value.plevel = obj.plevel
  moveForm.value.name = obj.name
}
const doMoveTask = () => {
  if (moveForm.value.name == "") {
    ElMessage.error("请填写任务名称");
    return;
  }
  if (!moveForm.value.projectid) {
    ElMessage.error("请选择项目名称");
    return;
  }
  if (moveForm.value.diygroup == "") {
    ElMessage.error("请选择任务分组");
    return;
  }
  moveProjectTask(moveForm.value).then((res) => {
   console.log(res)
   getListProjectTask();
   dialogMoveFormVisible.value = false
  });
}

//拷贝任务
const dialogCopyFormVisible = ref(false)
const copyForm = ref({
  projectid: null,
  taskid: null,
  name: '',
  plevel:'',
  diygroup:'',
})
const doCopyTaskOperate = (obj) => {
  dialogCopyFormVisible.value = true 
  copyForm.value.taskid = obj.taskid
  copyForm.value.plevel = obj.plevel
  copyForm.value.name = obj.name
}
const doCopyTask = () => {
  if (copyForm.value.name == "") {
    ElMessage.error("请填写任务名称");
    return;
  }
  if (!copyForm.value.projectid) {
    ElMessage.error("请选择项目名称");
    return;
  }
  if (copyForm.value.diygroup == "") {
    ElMessage.error("请选择任务分组");
    return;
  }
  copyProjectTask(copyForm.value).then((res) => {
   console.log(res)
   getListProjectTask();
   dialogCopyFormVisible.value = false
  });
}

//项目表API
const projectData = ref([]);
const selectProject = (e) => {
  projectid.value = e.projectid
  queryParam.value.projectid = e.projectid

  loadingData.value = true

  checkProjectUser.value = false
  console.log('selectProject1---',checkProjectUser.value)

  getListUser();
  console.log('selectProject2---',checkProjectUser.value)

  setTimeout(() => {
    if (e.privacy==2) {
      if (!checkProjectUser.value) {
        ElMessage.error('此项目被设置成不公开，只有本项目成员才可以查看。')
        loadingData.value = false
        return
      }
    }
  
    getListProjectConfig();
    getListProjectTask();

  }, 500);
  
  
};
const propsProject = ref({
  checkStrictly: true,
  value: "projectid",
  label: "name",
});
const projectReset = (projects) => {
  let dataTmp = [];
  projects.forEach((project) => {
    project.projectid = project.projectid.toString();
    dataTmp.push(project);
  });
  return dataTmp;
};
const getListProject = () => {
  listProject({ pageNo: 1, pageSize: 5000, isdelete: 1 }).then((res) => {
    projectData.value = projectReset(res.data.extend.pages.list);
    projectid.value = projectData.value[0].projectid;
    queryParam.value.projectid = projectData.value[0].projectid;
    taskForm.value.projectid = projectData.value[0].projectid;
  });
};

//任务
const tableData = ref([])
const newData = ref([])
const taskDataChild = ref([])
const taskDataAttachment = ref([])
const totalAttachment = ref()
const taskDataLog = ref([])
const totalLog = ref()
const header = ref()

const tlevel = ref(1)//层级
const tgroup = ref('group')//分组
const torder = ref('created')//排序

const doDefaultValue = (val) => {
  console.log('tgroup.value',tgroup.value)
  if (tgroup.value == 'group') { taskForm.value.diygroup = val }
  if (tgroup.value == 'status') { taskForm.value.status = val }
  if (tgroup.value == 'level') { taskForm.value.level = val }
  if (tgroup.value == 'tag') { taskForm.value.tag = val }
  if (tgroup.value == 'leader') { taskForm.value.leaderid = val }
}

const taskReset = () => {
  let b = []
  if (tgroup.value == 'group') {
    header.value = configForm.value.groups
    b = tableData.value.reduce((res, item) => {
      let parent = res.find(i => i.key === item.diygroup)
      if(parent){
          if (item.plevel <= tlevel.value) {
            parent.childList.push({item})
          }
      }else{
        if (item.plevel <= tlevel.value) {
          res.push({key: item.diygroup, childList: [{item}]})
        }
      }
      return res
    }, [])
  }
  if (tgroup.value == 'status') {
    header.value = configForm.value.status
    b = tableData.value.reduce((res, item) => {
      let parent = res.find(i => i.key === item.status)
      if(parent){
        if (item.plevel <= tlevel.value) {
          parent.childList.push({item})
        }
      }else{
        if (item.plevel <= tlevel.value) {
          res.push({key: item.status, childList: [{item}]})
        }
      }
      return res
    }, [])
  }
  if (tgroup.value == 'level') {
    header.value = configForm.value.levels
    b = tableData.value.reduce((res, item) => {
      let parent = res.find(i => i.key === item.level)
      if(parent){
        if (item.plevel <= tlevel.value) {
          parent.childList.push({item})
        }
      }else{
        if (item.plevel <= tlevel.value) {
          res.push({key: item.level, childList: [{item}]})
        }
      }
      return res
    }, [])
  }
  if (tgroup.value == 'tag') {
    header.value = configForm.value.tags
    b = tableData.value.reduce((res, item) => {
      let parent = res.find(i => i.key === item.tag)
      if(parent){
        if (item.plevel <= tlevel.value) {
          parent.childList.push({item})
        }
      }else{
        if (item.plevel <= tlevel.value) {
          res.push({key: item.tag, childList: [{item}]})
        }
      }
      return res
    }, [])
  }
  if (tgroup.value == 'leader') {
    let tmp = []
    b = tableData.value.reduce((res, item) => {
      let parent = res.find(i => i.key === item.leader.nickname)
      if(parent){
        if (item.plevel <= tlevel.value) {
          parent.childList.push({item})
        }
      }else{
        if (item.plevel <= tlevel.value) {
          tmp.push({configvalue:item.leader.nickname,configname:item.leader.nickname})
          res.push({key: item.leader.nickname, childList: [{item}]})
        }
      }
      return res
    }, [])
    header.value = tmp

  }
  if (tgroup.value == 'create') {
    let tmp = []
    b = tableData.value.reduce((res, item) => {
      let parent = res.find(i => i.key === item.user.nickname)
      if(parent){
        if (item.plevel <= tlevel.value) {
          parent.childList.push({item})
        }
      }else{
        if (item.plevel <= tlevel.value) {
          tmp.push({configvalue:item.user.nickname,configname:item.user.nickname})
          res.push({key: item.user.nickname, childList: [{item}]})
        }
      }
      return res
    }, [])
    header.value = tmp
  }
  newData.value = b
}

const changeTaskOrder = (order) => {
  queryParam.value.orderField = order
  queryParam.value.orderType = 'desc'
  torder.value = order
  getListProjectTask()
}

const changeTaskLevel = (level) => {
  tlevel.value = level
  taskReset()
}
const changeTaskGroup = (group) => {
  tgroup.value = group
  taskReset()
}

const getProjectTaskInfos = (taskid) => {
  getProjectTaskInfo({taskid}).then((res) => {
    console.log(res)
    taskForm.value = res.data.extend.task
    parentid.value = taskForm.value.parentid

    if (taskForm.value.parentid) {
      pname.value = taskForm.value.ptask.name
    } else {
      pname.value = ''
    }

    editorQuestionRef.value.valueHtml = taskForm.value.question;
    editorHelpRef.value.valueHtml = taskForm.value.help;
    editorContentRef.value.valueHtml = taskForm.value.content;
  });
};

const getListProjectTask = () => {
  listProjectTask(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false;
    taskReset()
  });
};

const getListProjectTaskChild = () => {
  listProjectTask(queryParamChild.value).then((res) => {
    totalChild.value = res.data.extend.pages.total;
    taskDataChild.value = res.data.extend.pages.list;
    loadingData.value = false;
  });
};

//附件列表
const getListProjectTaskAttachment = () => {
  listProjectTaskAttachment(queryParamAttachmentLog.value).then((res) => {
    totalAttachment.value = res.data.extend.pages.total;
    taskDataAttachment.value = res.data.extend.pages.list;
    loadingData.value = false;
  });
};

//文件下载
const doDownloadProjectTaskAttachment = (path,filenames,suffix)=>{
    download({fileName:path}).then((res)=>{
        let fileName = filenames+suffix
        const blob = new Blob([res.data]);
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放URL 对象
        document.body.removeChild(elink);
    })
}
//日志列表
const getListProjectTaskLog = () => {
  listProjectTaskLog(queryParamAttachmentLog.value).then((res) => {
    totalLog.value = res.data.extend.pages.total;
    taskDataLog.value = res.data.extend.pages.list;
    loadingData.value = false;
  });
}
const getConfigNameLog = (field, val) => {
  if (field === 'status') { return getConfigName(1, val) }
  else if (field === 'diygroup') { return getConfigName(2, val) }
  else if (field === 'tag') { return getConfigName(3, val) }
  else if (field === 'level') { return getConfigName(4, val) }
  else if (field === 'started') { return util.formatDateUnix(val * 1, "MM月dd日 hh:mm") }
  else if (field === 'ended') { return util.formatDateUnix(val * 1, "MM月dd日 hh:mm") }
  else { return val }
}
//流转
const taskDataStatus = ref([])
const getListProjectTaskStatus = () => {
  listProjectTaskLog(queryParamAttachmentLog.value).then((res) => {
    let data = res.data.extend.pages.list
    let dataTmp = []
    data.forEach((item) => {
      if (item.field == 'status') {
        let status = getConfigName(1, item.tos)
        let color = 'danger'
        if (status === '进行中') { color = 'warning'}
        if (status === '已完成') { color = 'success'}
        dataTmp.push({
          nickname:item.user.nickname, 
          status:status, 
          color: color,
          timestamp:util.formatDateUnix(item.created * 1, "MM月dd日 hh:mm")
        })
      }
    });
    loadingData.value = false
    taskDataStatus.value = dataTmp
  });
}

const shortcuts = [
  {
    text: "今天",
    value: new Date(),
  },
  {
    text: "昨天",
    value: () => {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);
      return date;
    },
  },
  {
    text: "一周前",
    value: () => {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      return date;
    },
  },
];

const doUploadSuccess = (response) => {  
  if (response.code === 0) {    
    ElMessage.error(response.msg)
  } else {
    console.log(response)
    // getListProjectTaskAttachment()
  }
};

const headerUpload = ref({
  Authorization: store.state.user.token,
});
</script>
<style>
.cimg {
  cursor: pointer;
}
.cimg img {
  width:300px;
}
</style>
<style scoped>
.txted {
  color: #999;
  font-size: 13px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

:deep(.box-card .el-card__header) {
  padding:10px 10px 5px 10px;
  border-bottom:none
}

/* {
  margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f4f4f4;
} */

:deep(.search-input .el-input__wrapper) {
  border: none;
  box-shadow: none !important;
  padding: 0;
}

:deep(.date-input .el-input__wrapper) {
  border: none;
  box-shadow: none !important;
  padding: 0;
}

:deep(.date-input .el-input.is-focus .el-input__wrapper),
:deep(.date-input .el-input .el-input__wrapper:hover) {
  border: none;
  box-shadow: none !important;
}
:deep(.date-input .el-input__prefix) {
  display: none;
}

:deep(.title-input .el-input__wrapper) {
  border: none;
  box-shadow: none;
  font-size: 16px;
  font-weight: bold;
}
:deep(.title-input .is-focus) {
  box-shadow: 0 0 0 1px var(--el-input-focus-border-color) inset;
}

:deep(.my-label) {
  color: #999;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.box-card {
  width: 280px;
}
.popverli {
  margin: 0;
  padding: 0;
}
.popverli li {
  list-style: none;
  padding: 10px;
}
.popverli li i {
  vertical-align: -2px;
  padding-right: 5px;
}

.taskbox {
  /* padding:10px 0;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 15px; */
  cursor: pointer;

  padding: 10px;
  border: 1px solid #e4e7ed;
  margin-bottom: 15px;
  border-radius: 5px;
}

.tasktitle {
  justify-content: space-between;
  display: flex;
}
.tasktitle h1 {
  font-weight: normal;
  font-size: 15px;
  margin: 0;
}
.taskstatus {
  justify-content: space-between;
  display: flex;
  margin-bottom: 5px;
}
.tasktime {
  margin-bottom: 5px;
}
.tasktime .el-tag {
  margin-bottom: 5px;
}
.scrollbar-flex-content {
  display: flex;
}
.scrollbar-demo-item1 {
  flex-shrink: 0;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  /* width: 100px;
  height: 50px; */
  margin: 10px;
  /* text-align: center; */
  border-radius: 4px;
  /* background: var(--el-color-danger-light-9);
  color: var(--el-color-danger); */
}
.scrollbar-demo-item {
  flex-shrink: 0;
  display: flex;
  /* align-items: center;
  justify-content: center; */
  width: 100px;
  height: 50px;
  margin: 10px;
  text-align: center;
  border-radius: 4px;
  /* background: var(--el-color-danger-light-9);
  color: var(--el-color-danger); */
}
.active {
  color: var(--el-link-hover-text-color);
}
</style>